export const HORSES_V2_ENDPOINTS = Object.freeze({
  history: '/centerhorsesv2/report/ticket/history',
  racecourses: '/centerhorsesv2/racecourses',
  ticketStatus: '/centerhorsesv2/ticketStatus',
  ticketDetail: '/centerhorsesv2/report/ticket/detail',
  export: '/export-center-horses-v2-history',
})

const badge = variant => `badge badge-${variant} p-1 rounded`

export const HORSES_V2_STATUSES = Object.freeze({
  pendiente: { labelKey: 'status.pending', className: badge('info') },
  perdido: { labelKey: 'status.lost', className: badge('danger') },
  ganado: { labelKey: 'status.won', className: badge('success') },
  anulado: { labelKey: 'status.null_bet', className: badge('dark') },
  pagado: { labelKey: 'status.paid', className: badge('success') },
  vencido: { labelKey: 'status.expired', className: badge('dark') },
  devolucion: { labelKey: 'status.return', className: badge('dark') },
  'en juego': { labelKey: 'status.ingame', className: badge('warning') },
})

const isNil = value => value === null || value === undefined

export const normalizeHorsesV2Status = value => (isNil(value) ? '' : String(value))
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ')
  .trim()
  .toLowerCase()

export const horsesV2Status = value => {
  const normalized = normalizeHorsesV2Status(value)
  if (!normalized) return { labelKey: null, text: '-', className: '' }

  const status = HORSES_V2_STATUSES[normalized]
  if (status) return { ...status, text: '' }

  return {
    labelKey: null,
    text: String(value).trim(),
    className: badge('secondary'),
  }
}

export const toAmount = value => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export const horsesV2Totals = items => (Array.isArray(items) ? items : []).reduce(
  (totals, item) => ({
    amountBet: totals.amountBet + toAmount(item && item.amountBet),
    amountPrize: totals.amountPrize + toAmount(item && item.amountPrize),
    amountRetired: totals.amountRetired + toAmount(item && item.amountRetired),
  }),
  { amountBet: 0, amountPrize: 0, amountRetired: 0 },
)

export const horsesV2Options = data => {
  if (Array.isArray(data)) return data
  if (data && Array.isArray(data.data)) return data.data
  return []
}

export const toFilterValue = value => (isNil(value) ? '' : value)

export const normalizeHorsesV2TicketId = value => (isNil(value) ? '' : String(value).trim())

export const isHorsesV2TicketId = value => /^\d+$/.test(normalizeHorsesV2TicketId(value))

export const horsesV2Message = (message, fallback) => {
  if (Array.isArray(message)) return message.filter(Boolean).join('. ') || fallback
  return typeof message === 'string' && message.trim() ? message.trim() : fallback
}
